import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalModule } from '@app/core/global.module';
import { ConfirmCloseDialogComponent } from '@components/dialog/children/confirm-close-dialog/confirm-close-dialog.component';
import { ButtonModule } from '../../button/modules/button.module';
import { ConfirmDialogComponent } from '../children/confirm-dialog/confirm-dialog.component';
import { DialogComponent } from '../component/dialog.component';
import { AppDialogService } from '../services/app-dialog.service';

@NgModule({
    declarations: [DialogComponent, ConfirmDialogComponent, ConfirmCloseDialogComponent],
    exports: [DialogComponent],
    imports: [CommonModule, GlobalModule, A11yModule, ButtonModule],
    providers: [AppDialogService],
})
export class AppDialogModule {}
